import { Capacitor } from '@capacitor/core';
import { FilePicker } from '@capawesome/capacitor-file-picker';

// Native-only: opens the photo library (no camera option) and returns a File, or null if cancelled.
export async function pickLibraryMedia() {
  let picked;
  try {
    // skipTranscoding:false keeps iOS converting HEIC/HEVC to JPEG/H.264, matching the web file input.
    const { files } = await FilePicker.pickMedia({ limit: 1, skipTranscoding: false });
    picked = files?.[0];
  } catch (err) {
    if (/cancel/i.test(err?.message || '')) return null;
    throw err;
  }
  if (!picked?.path) return null;
  const blob = await (await fetch(Capacitor.convertFileSrc(picked.path))).blob();
  return new File([blob], picked.name, {
    type: picked.mimeType || blob.type,
    lastModified: picked.modifiedAt || Date.now(),
  });
}
